import { Meta } from "@/shared/components";
import { MailerConfigs } from "@/admin/features/mailerConfigs";

export function MailerConfigsPage() {
  return (
    <>
      <Meta title="Мейлеры" />
      <MailerConfigs />
    </>
  );
}
